export const TABLES = 'TABLES';
export const GET_TABLE_REQUEST = `${TABLES}/getTablesRequest`;
export const ADD_TABLE_REQUEST = `${TABLES}/addTablesRequest`;
export const REMOVE_TABLE_REQUEST = `${TABLES}/removeTablesRequest`;
export const GENERATE_PDF_REQUEST = `${TABLES}/generatePdfRequest`;
